export default __webpack_public_path__ + "static/media/pult.bfb371dd.svg";